/**
 * Created by abdulhafeth on 12/15/15.
 */
window.searchConfiguration = {};
searchConfiguration.defaultFilteration = {
    'jobs': 5,
    'big_jobs': 7,
    'members': 12,
    'big_members': 14,
    'companies': 5,
    'big_companies': 7
};
searchConfiguration.searchFiltersLimitations = {
    'default': 11,
    'skills': 11,
    'HECS': 11,
    'cusine': 11,
    'positions': 11,
    'brands': 11,
    'statuses': 11,
    'types': 11
};

searchConfiguration.GRIDS_TEMPLATES = {
    MEMBERS: "../modules/docs/views/employer/people-result.html",
    CANDIDATE_DOCUMENTS: "../modules/docs/views/candidate/people-result.html"
};

searchConfiguration.WIDGETS_TMPLS = {
    MEMBERS: "../modules/docs/views/employer/docs_member_widget.html",
    CANDIDATE_DOCUMENTS: "../modules/docs/views/candidate/docs_member_widget.html"
};

searchConfiguration.DOCUMENT_STATE_ICON_STYLE = {
    REQUESTED: "fa-warning",
    PENDING: "fa-warning",
    SIGNED: "fa-check-circle",
    APPROVED: "fa-check-circle",
    C_REJECTED: "fa-minus-circle",
    WITHDRAWN: "fa-minus-circle",
    SKIPPED: "fa-pause-circle"
};

searchConfiguration.CANDIDATE_TYPES = {
    ACTIVE_HIRED: "ACTIVE_HIRED",
    ACTIVE_ON_BOARDING: "ACTIVE_ON_BOARDING",
    ACTIVE_APPLICANT: "ACTIVE_APPLICANT",
    ARCHIVED: "ARCHIVED",
    ALL: "ALL"
};

searchConfiguration.CANDIDATE_TYPES_STATES = {
    ACTIVE_HIRED: "employees",
    ACTIVE_ON_BOARDING: "onboards",
    ACTIVE_APPLICANT: "applicants",
    ARCHIVED: "archived",
    ALL: "all"
};


searchConfiguration.DocsStatesMapping = {
    "employees": searchConfiguration.CANDIDATE_TYPES.ACTIVE_HIRED,
    "onboards": searchConfiguration.CANDIDATE_TYPES.ACTIVE_ON_BOARDING,
    "applicants": searchConfiguration.CANDIDATE_TYPES.ACTIVE_APPLICANT,
    "archived": searchConfiguration.CANDIDATE_TYPES.ARCHIVED,
    "all": searchConfiguration.CANDIDATE_TYPES.ALL
};
